type Listener = () => void

type Phase = 'reveal' | 'complete'

const reached: Record<Phase, boolean> = {
    reveal: false,
    complete: false
}

const listeners: Record<Phase, Set<Listener>> = {
    reveal: new Set(),
    complete: new Set()
}

const subscribe = (phase: Phase, listener: Listener): (() => void) => {
    if (reached[phase]) {
        listener()
        return () => undefined
    }

    listeners[phase].add(listener)
    return () => {
        listeners[phase].delete(listener)
    }
}

const emit = (phase: Phase): void => {
    if (reached[phase]) return
    reached[phase] = true
    listeners[phase].forEach((listener) => listener())
    listeners[phase].clear()
}

/** Fires when the intro curtain starts lifting (or immediately if it already has). */
export const onIntroReveal = (listener: Listener): (() => void) => subscribe('reveal', listener)

/** Fires when the intro has fully finished and scrolling is unlocked. */
export const onIntroComplete = (listener: Listener): (() => void) => subscribe('complete', listener)

/** Whether the curtain has already started lifting. */
export const introRevealed = (): boolean => reached.reveal

export const markIntroReveal = (): void => emit('reveal')

export const markIntroComplete = (): void => {
    emit('reveal')
    emit('complete')
}
